import { cn } from "@/lib/utils";
import { APP_NAME } from "@/lib/constants";

export function Logo({ collapsed = false, className, markClassName }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)} data-testid="app-logo">
      <img
        src="/fulfillflow-mark.png"
        alt="FulfillFlow"
        className={cn("h-9 w-9 shrink-0 object-contain", markClassName)}
      />
      {!collapsed && (
        <span className="text-lg font-bold tracking-tight text-foreground">{APP_NAME}</span>
      )}
    </div>
  );
}
